<template>
    <b-input-group-append>
        <slot />
    </b-input-group-append>
</template>

<script>
import {BInputGroupAppend} from 'bootstrap-vue'

export default {
    components: {BInputGroupAppend},
}
</script>